<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchForm.organizeName" placeholder="组织名称" clearable style="width: 200px" />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.creatorName" placeholder="创建者" clearable style="width: 150px" />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.subscribePlan"
          placeholder="订阅计划"
          clearable
          style="width: 150px">
          <el-option
            v-for="item in subscribePlanOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="organizeDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getList">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="id" label="ID" width="180" show-overflow-tooltip />
      <el-table-column prop="organizeName" label="组织名称" min-width="200" show-overflow-tooltip />
      <el-table-column prop="creatorName" label="创建者" width="150" show-overflow-tooltip />
      <el-table-column prop="memberCount" label="成员数量" width="120" />
      <el-table-column prop="subscribePlan" label="订阅计划" width="150" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" width="180" />
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total"
    />
  </div>
</template>

<script>
export default {
  name: 'Organize',
  data () {
    return {
      searchForm: {
        organizeName: '',
        creatorName: '',
        subscribePlan: ''
      },
      organizeDate: null,
      subscribePlanOptions: [],
      tableData: [],
      page: { total: 0, size: 10, current: 1 }
    }
  },
  created () {
    this.getSubscribePlanOptions()
    this.getList()
  },
  methods: {
    handleSizeChange (val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getList()
    },
    getSubscribePlanOptions () {
      this.$axios.get('/uxm/config/list', {}).then(res => {
        if (res && res.data && res.data.data) {
          // 提取所有订阅计划名称，保持后端返回的顺序（按ID排序）
          const roleNames = res.data.data
            .map(item => item.roleName)
            .filter(name => name && name.trim() !== '')
          // 去重但保持顺序
          const uniqueRoleNames = []
          const seen = new Set()
          for (const name of roleNames) {
            if (!seen.has(name)) {
              seen.add(name)
              uniqueRoleNames.push(name)
            }
          }
          
          // 构建下拉选项，第一项为"全部"
          this.subscribePlanOptions = [
            { label: '全部', value: '' },
            ...uniqueRoleNames.map(name => ({ label: name, value: name }))
          ]
        }
      }).catch(error => {
        console.error('获取订阅计划列表失败:', error)
        // 如果获取失败，至少提供"全部"选项
        this.subscribePlanOptions = [{ label: '全部', value: '' }]
      })
    },
    getList () {
      const params = {
        organizeName: this.searchForm.organizeName,
        creatorName: this.searchForm.creatorName,
        subscribePlan: (this.searchForm.subscribePlan === '' || this.searchForm.subscribePlan == null) ? null : this.searchForm.subscribePlan,
        startDate: this.organizeDate === null ? null : this.organizeDate[0],
        endDate: this.organizeDate === null ? null : this.organizeDate[1],
        current: this.page.current,
        size: this.page.size
      }
      this.$axios.post('/uxm/organize/page', params).then(res => {
        const data = res.data.data
        this.tableData = data.records || []
        this.page.total = data.total || 0
        this.page.size = data.size || this.page.size
        this.page.current = data.current || this.page.current
      }).catch(error => {
        console.error('获取组织列表失败:', error)
        this.tableData = []
        this.page.total = 0
      })
    }
  }
}
</script>

<style scoped>
.el-pagination { float: right; margin-top: 22px; }
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>